import { useSelector } from "react-redux"

function useGetBranchDetails() {
  const { selectedBranch } = useSelector(state => ({
    selectedBranch: state.Branches.selectedBranch,
  }))
  return { branch: selectedBranch?.label, branchId: selectedBranch?.value }
}

export default useGetBranchDetails
